import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "contexts/AuthContext";
// material-ui
import { Checkbox, ListItemButton, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import NavItem from "./NavItem";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { currentUser, setCurrentUser } = useContext(AuthContext);
  const customization = useSelector((state) => state.customization);
  const [refreshing, setRefreshing] = useState(false);

  const refreshHubspotMutation = useMutation({
    mutationFn: () => {
      return axios.get("/api/v2/organizations/sync", {});
    },
    onSettled: () => {
      setRefreshing(false);
    },
  });

  let navItems = [];

  // Separating menu items by role
  if (currentUser.role === "Admin") {
    navItems = menuItem.items.filter((item) => item.type !== "toggle");
  } else if (currentUser.role === "Organization Admin") {
    navItems = menuItem.items.filter((item) => item.id !== "refreshHubspotButton");
  } else {
    navItems = menuItem.items.filter((item) => item.id !== "refreshHubspotButton");
  }

  navItems = navItems.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      case "toggle":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
            <Checkbox
              value="check"
              checked={currentUser.role === "Organization Admin"}
              onChange={() =>
                currentUser.role === "Organization Admin"
                  ? setCurrentUser({ ...currentUser, role: "User" })
                  : setCurrentUser({ ...currentUser, role: "Organization Admin" })
              }
              color="dark"
              style={{ background: "white" }}
            >
              <CheckIcon />
            </Checkbox>
            <Typography>Organization Admin</Typography>
          </div>
        );
      case "button":
        return (
          <ListItemButton
            sx={{
              borderRadius: `${customization.borderRadius}px`,
              border: "1px solid #fff",
              mb: 0.5,
              alignItems: "flex-start",
              backgroundColor: "transparent !important",
              color: "#fff",
              py: 1.25,
              pl: "24px",
            }}
            onClick={() => {
              refreshHubspotMutation.mutate();
              setRefreshing(true);
            }}
            disabled={refreshing}
          >
            {item.title}
          </ListItemButton>
        );
      default:
        return <NavItem key={item.id} item={item} />;
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
